import React, { useState } from 'react';

import { translate } from '@vimeo/i18n-runtime';
import { Radio } from '@vimeo/iris/components';
import { LoaderCircular } from '@vimeo/iris/motion';
import { themes } from '@vimeo/iris/themes';
import { Paragraph } from '@vimeo/iris/typography';

import { setLanguage, Locales } from '../../setLanguage';
import { Form, FormError, SubmitButton } from './Form';

interface Props {
  locale: string;
  locales: Locales[];
  localeLabels: string[];
  token: string;
}

function LanguageForm({ locale, locales, localeLabels, token }: Props) {
  const [error, setError] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [localeLanguage, setLocaleLanguage] = useState(locale);

  return (
    <Form
      onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsSaving(true);
        setError('');

        const target = event.target as HTMLFormElement;

        setLanguage({ token, locale: localeLanguage }).then((response: Response) => {
          setIsSaving(false);

          if (!response.ok) {
            setError(translate('Sorry, something weird happened. Please try again.'));
          } else {
            // Refresh the page to update the language choice
            window.location.reload();
          }
        });
      }}
    >
      {error ? (
        <FormError>
          <Paragraph size="2" style={{ margin: 0 }}>
            {error}
          </Paragraph>
        </FormError>
      ) : null}
      {locales.map((currLocale, i) => (
        <Radio
          checked={currLocale === localeLanguage}
          id={currLocale}
          key={i}
          label={localeLabels[i]}
          name="language"
          onChange={() => setLocaleLanguage(currLocale)}
          value={currLocale}
        />
      ))}
      <SubmitButton type="submit" loading={isSaving}>
        {translate('Confirm')}
      </SubmitButton>
    </Form>
  );
}

export default LanguageForm;
